import React, { FC } from 'react';
import { Doughnut } from 'react-chartjs-2';
import type { ChartData, ChartOptions, Plugin } from 'chart.js';
import { CardWrapper } from '../../CardWrapper/CardWrapper';
import styles from './DoughnutChart.module.scss';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { isNaN } from 'lodash';
import NoData from './NoData/NoData';

const options: ChartOptions<'doughnut'> = {
	cutout: '50%',
	responsive: true,
	maintainAspectRatio: false,
	aspectRatio: 0.8,
	rotation: 20,
	elements: {
		arc: {
			borderWidth: 0,
			borderAlign: 'center',
		},
	},
	layout: {
		padding: 40,
	},
	animation: false,
	plugins: {
		legend: {
			display: false,
		},
		datalabels: {
			formatter: function (value, context) {
				let sum = 0;
				const dataArr = context.chart.data.datasets[0].data;
				dataArr.map((data) => {
					const val = !isNaN(data) ? Number(data) : 0;
					sum += val;
				});
				const percentage = ((value * 100) / sum).toFixed(1) + '%';
				return `${context?.chart?.data?.labels ? context?.chart?.data?.labels[context?.dataIndex] : ''}
				${percentage}`;
			},
			display: 'auto',
			color: 'white',
			anchor: 'end',
			align: 'end',
			offset: 3,
			labels: {
				value: {
					color: '#ADADAD',
				},
			},
		},
	},
};

interface DoughnutChartProps {
	data: ChartData<'doughnut'>;
	title: string;
	className?: string;
}

const DoughnutChart: FC<DoughnutChartProps> = ({ data, title, className }): JSX.Element => {
	const hasData = data.datasets[0]?.data?.some((value) => value > 0);
	return (
		<CardWrapper backgroundColor='#37414a' className={className}>
			<div className={styles.Content}>
				<h4 className={styles.Title}>{title}</h4>
				<div className={styles.ChartSection}>
					<div className={styles.Chart}>
						{hasData ? (
							<Doughnut options={options} data={data} plugins={[ChartDataLabels as Plugin<'doughnut'>]} />
						) : (
							<NoData />
						)}
					</div>
				</div>
			</div>
		</CardWrapper>
	);
};

export default DoughnutChart;
